module.exports = __webpack_public_path__ + "static/media/DotGreen.7485674b.svg";